const slider = document.querySelector('.slider');
const seriesLabel = document.getElementById('series_label');
const productsLabel = document.getElementById('products_label');

function applySlider() {
    const value = slider.value;
    const series = document.querySelector(".section");
    const products = document.querySelector(".collection");
    if (series && products) {
        series.style.display = value == 0 ? '' : 'none';
        products.style.display = value == 1 ? '' : 'none';
    }
    seriesLabel.classList.toggle('is-active', value == 0);
    productsLabel.classList.toggle('is-active', value == 1);
}

document.addEventListener('DOMContentLoaded', () => {
    slider.value = localStorage.getItem('slider') || 0;
    applySlider();
});

slider.addEventListener('input', () => {
    applySlider();
    localStorage.setItem("slider", `${slider.value}`);
});

[[seriesLabel, 0], [productsLabel, 1]].forEach(([label, v]) => label.addEventListener('click', () => {
    slider.value = v;
    slider.dispatchEvent(new Event('input'));
}));
